import { Box, Typography } from "@mui/material";
import styles from "../ServicesMenu/services.module.scss";

const YoungAdultActivity = () => {
  return (
    <Box className={styles.YoungadultactivitytotalLaout}>
      <Typography className={styles.header}>
        HCCC InCircle Mentorship Program{" "}
      </Typography>
      <Box className={styles.images} sx={{ mb: "20px" }}>
        <Box
          component="img"
          sx={{
            width: { xs: "100%", md: "80%", lg: "45%" },
            borderRadius: "6px",
          }}
          src={`${process.env.REACT_APP_BASE_ASP_URL}/hints/youngadults/2024/HCCC_YoungAdult_MentorshipApplication1.jpg`}
          // src="https://hints20.livermoretemple.org/hints/youngadults/2024/HCCC_YoungAdult_MentorshipApplication1.jpg"
        />
        <a href="https://forms.gle/AfzkvWukiPGMRCmB6" target="_blank">
          <Box
            component="img"
            sx={{
              // width: { xs: "100%", md: "80%", lg: "45%" },
              // height:{ xs: "200%", md: "80%", lg: "45%" },
              width:"85%",
              height:"820px",
              borderRadius: "6px",
            }}
            src={`${process.env.REACT_APP_BASE_ASP_URL}/hints/youngadults/2024/HCCC_YoungAdult_MentorshipApplication2.jpg`}
            alt="Your Image Alt Text"
          />
        </a>
      </Box>
      <Typography className={styles.header}>
        HCCC and Global Mentorship Initiative{" "}
      </Typography>
      <Box
        component="img"
        sx={{
          width: { xs: "100%", md: "80%", lg: "45%" },
          mb: "20px",
          borderRadius: "6px",
        }}
        src={`${process.env.REACT_APP_BASE_ASP_URL}/hints/youngadults/2024/Hindu_Community&CulturalCenter-GMI_Student_Flyer.jpg`}
        // src="https://hints20.livermoretemple.org/hints/youngadults/2024/Hindu_Community&CulturalCenter-GMI_Student_Flyer.jpg"
      />
      <Typography className={styles.details}>
        <span className={styles.summary}>
          <a
            href={`${process.env.REACT_APP_BASE_ASP_URL}/hints/youngadults/2024/HCCC_YoungAdults_VolunteerCampaign_01.01.24.pdf`}
            target="_blank"
          >
            Click here
          </a>
        </span>{" "}
        to access the Presentation and Additional Details
      </Typography>{" "}
      <br />
      <Typography className={styles.header}>
        Celebrating Volunteers and Inspiring Community Engagement{" "}
      </Typography>
      <Box
        component="img"
        sx={{
          width: { xs: "100%", md: "80%", lg: "45%" },
          borderRadius: "6px",
        }}
        src={`${process.env.REACT_APP_BASE_ASP_URL}/hints/youngadults/2024/VolunteersNeeded_for_YACommittee.jpg`}
        // src="https://hints20.livermoretemple.org/hints/youngadults/2024/VolunteersNeeded_for_YACommittee.jpg"
      />
      <Typography className={styles.header}>
        Young Adult Services offered at HCCC
      </Typography>
      <Box className={styles.images}>
        <Box
          component="img"
          sx={{
            width: { xs: "100%", md: "80%", lg: "45%" },
            borderRadius: "6px",
          }}
          src={`${process.env.REACT_APP_BASE_ASP_URL}/hints/youngadults/2024/YoungAdultServices.jpg`}
          // src={`${process.env.REACT_APP_BASE_ASP_URL}/hints/youngadults/2024/YoungAdultServices.jpg`}
        />
        <Box
          component="img"
          sx={{
            width: { xs: "100%", md: "80%", lg: "45%" },
            borderRadius: "6px",
          }}
          src={`${process.env.REACT_APP_BASE_ASP_URL}/hints/youngadults/2024/YoungAdultServices2.jpg`}
          // src={`${process.env.REACT_APP_BASE_ASP_URL}/hints/youngadults/2024/YoungAdultServices2.jpg`}
        />
      </Box>
    </Box>
  );
};
export default YoungAdultActivity;
